import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      measurements: null,
      topMeasurements: null,
    }
  },
  watch: {
    _storeMeasurements: {
      immediate: true,
      handler(val) {
        this.measurements = val
      }
    },
    _storeTopMeasurements: {
      immediate: true,
      handler(val) {
        this.topMeasurements = val
      }
    }
  },
  methods: {
    async setTenderMeasurements() {
      if ((!this.measurements || !this.measurements.length) && this.tender) {
        await this.$store.dispatch('setTenderMeasurements')
      }
    },
    async setTopMeasurements() {
      if ((!this.topMeasurements || !this.topMeasurements.length) && this.tender) {
        await this.$store.dispatch('setTopMeasurements')
      }
    },
    getMeasure(item) {
      let t = ''
      if (item.unit) {
        t = item.unit.title
      } else if (item.measuringUnit) {
        const measureName = this.getMeasureName(item)
        if (measureName) {
          t = measureName.unitShortTitle ? measureName.unitShortTitle : this.$_getShortName(measureName.unitTitle)
        } else {
          t = item.measuringUnit
        }
      }
      return t
    },
    getMeasureName(item) {
      if (typeof item.measuringUnit == 'object') {
        return item.measuringUnit.shortName || item.measuringUnit.name
      }
      let measurement = this.measurements?.find(el => el.unitCode == item.measuringUnit)
      return measurement
    },
  },
  computed: {
    ...mapGetters({
      _storeMeasurements: 'getMesurementUnit',
      _storeTopMeasurements: 'getTopMesurementUnit'
    }),
    isTopMeasure() {
      return !!this.topMeasurements?.length
    },
    groupsMeasurements() {
      const measurements = this.$_.cloneDeep(this.measurements)
      const convert = (items) => {
        if (!items?.length) {
          return []
        }
        return items.map(item => {
          const unitShortTitleLower = item.unitShortTitle.toLowerCase()
          const unitTitleLower = item.unitTitle.toLowerCase()
          return {
            unitShortTitleLower,
            unitTitleLower,
            unitFilter: `${unitTitleLower}_${unitShortTitleLower}`,
            ...item
          }
        })
          .sort((a, b) => (a.unitTitleLower ?? '').localeCompare(b.unitTitleLower ?? ''))
      }
      const result = {
        measurements: this.isTopMeasure ? [] : convert(measurements),
        topMeasurements: convert(this.topMeasurements)
      }

      if (this.isTopMeasure) {
        const topMeasurementCodes = this.topMeasurements.map(item => item.unitCode)
        result.measurements = convert(
          measurements.filter(measurement => {
            return !topMeasurementCodes.includes(measurement.unitCode)
          })
        )
      }
      return result
    }
  }
}
